import { render, staticRenderFns } from "./AdminBottomNavigation.vue?vue&type=template&id=f3138fac&scoped=true"
import script from "./AdminBottomNavigation.vue?vue&type=script&lang=js"
export * from "./AdminBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./AdminBottomNavigation.vue?vue&type=style&index=0&id=f3138fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3138fac",
  null
  
)

export default component.exports